export const PAGINATION_LIMITS = {
    TWENTY: 20,
    FIFTY: 50,
    HUNDRED: 100,
    FIVE_HUNDRED: 500
}
